import * as types from './types';

export const fetchUsersAction = () => ({ type: types.USERS_DATA_FETCH });
export const fetchUsersSuccess = payload => ({ type: types.USERS_DATA_SUCCESS, payload });
export const fetchUsersFailure = () => ({ type: types.USERS_DATA_FAILURE });

export const selectUser = (user_id, eventName) => {
  const payload = user_id ? { user_id, eventName } : null;
  return { type: types.SELECT_USER, payload };
};
export const unselectUser = payload => ({ type: types.UNSELECT_USER, payload });

export const fetchUsers = ({ tag_id, segment_id, is_identified } = {}) => (
  (dispatch, getState, api) => {
    dispatch(fetchUsersAction());

    return api.getUsers({ tag_id, segment_id, is_identified })
      .then(response => {
        const payload = {
          users: response.data.users,
          next: response.data.pages.next,
        };

        dispatch(fetchUsersSuccess(payload));
      })
      .catch(error => {
        dispatch(fetchUsersFailure(error));
      });
  }
);

export const updateUsersData = payload => ({ type: types.UPDATE_USERS_DATA, payload });



// WEBPACK FOOTER //
// ./src/redux/users/actions.js